import { toast } from 'sonner';

import { logout } from '@/shared/auth/session';
import { i18n } from '@/shared/i18n/i18n';

/**
 * Signs out from the user menu or the command palette. When the server could not revoke the session the user stays
 * signed in (see `logout`) and a toast says so, with a retry.
 */
export function signOut(): void {
  logout().catch(() => {
    toast.error(i18n.t('app:userMenu.logoutFailed'), {
      id: 'sign-out-failed',
      description: i18n.t('app:userMenu.logoutFailedDescription'),
      action: { label: i18n.t('shared:actions.retry'), onClick: signOut },
    });
  });
}
